<!--列表查看视图-->
<template>
  <div>
    <div style="width: fit-content">
      <div style="display: flex; height: 590px">
        <div class="section form-column">
          <el-form label-width="112px" style="height:100%" :disabled="readonly">
            <el-form-item label="MBL">
              <el-input v-model="form.mbl" no="1" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MBLTransportationClause')">
              <cargo-advance-select
                no="freightTerm"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                filterable
                :clearable="false"
                :default-value="form.freightTerm"
                @parentCallBack="p=>{form.freightTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                no="paymentTermMBL"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :clearable="false"
                :default-value="form.paymentTermMBL"
                @parentCallBack="p=>{form.paymentTermMBL=p.value;pm.paymentTermMBLChange()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfMblPayment')">
              <el-input
                v-show="!pm.isShowAcPaymentPlaceBL"
                v-model="mblDoc.paymentPlaceBL"
                no="paymentPlaceBL"
                :disabled="!(isEdit && (form.paymentTermMBL==='3P' || form.paymentTermMBL==='PP'))"
                @change="pm.fieldChangeHandler()"
              />
              <cargo-advance-select
                v-if="pm.isShowAcPaymentPlaceBL"
                no="paymentPlaceBL"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="mblDoc.paymentPlaceBL||''"
                @parentCallBack="p=>{mblDoc.paymentPlaceBL = p.value}"
              />
            </el-form-item>
            <booking-sea-eq-data-grid
              v-if="form.containerLoadType==='FCL'||form.containerLoadType==='BB'||form.containerLoadType==='BCF'||form.containerLoadType==='BC'"
              ref="bookingSeaEqDataGrid"
              no="bookingSeaEqDataGrid"
              :value="seaEqList"
              :is-edit="false"
              :container-load-type="form.containerLoadType"
              :job="form"
              @eqQuantityChange="eqQuantityChangeHandler"
            />
          </el-form>
        </div>
        <div class="section form-column" style="width: 350px;">
          <el-form label-width="112px" label-position="right" style="height:100%" :disabled="readonly">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfLoading') }}</span>
              <div style="display: flex; justify-content: space-between">
                <cargo-advance-select
                  ref="loadingPortCode"
                  no="loadingPortCode"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="form.loadingPortCode"
                  tag-name="englishName"
                  style="flex:1"
                  @parentCallBack="p=>{pm.loadingPortCodeChange(p);pm.cargoDocChangeHandler();pm.changeLoadingPort();pm.setPlannerChange()}"
                />&nbsp;
                <el-checkbox v-model="form.transfering" no="transfering" style="padding-left:2px;" @change="pm.updateSecondVesselInfo()">{{ $t('SeaExport.Transit') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item
              v-show="form.transfering"
              :label="$t('SeaExport.TransitPort')"
            >
              <cargo-advance-select
                no="transferPortCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.transferPortCode"
                @parentCallBack="p=>{form.transferPortCode=p.value;pm.updateSecondVesselInfo()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfDischarge') }}</span>
              <cargo-advance-select
                no="dischargingPortCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode"
                @parentCallBack="p=>{pm.dischargingPortCodeChange(p.value,form.carrierId);pm.cargoDocChangeHandler();pm.changeDischargingPort()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PlaceOfDelivery') }}</span>
              <cargo-advance-select
                no="destinationPortCode"
                class="port-of-delivery-selector"
                popper-class="port-of-delivery-selector-popper"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode"
                @parentCallBack="p=>{pm.destinationPortCodeChange(p);pm.cargoDocChangeHandler();pm.changeDestinationPort()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('CargoMsg.Cargo_PlaceOfDeliveryRegion') }}</span>
              <cargo-advance-select
                no="placeOfDeliveryRegion"
                :select-type="selectTypeNames.basic_data_Region"
                filterable
                :default-value="form.placeOfDeliveryRegion"
                @parentCallBack="p=>{form.placeOfDeliveryRegion=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  no="etd"
                  class="departure-date-picker"
                  :value="form.etd"
                  :picker-options="{
                    disabledDate: disabledDate
                  }"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1;margin-right: 5px"
                  @input="etdChange"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.DateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.eta"
                  no="eta"
                  :picker-options="{
                    disabledDate: disabledDate
                  }"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="etaChange"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Vessel')">
              <cargo-advance-select
                no="5"
                :select-type="selectTypeNames.static_data_Vessel"
                :cache="false"
                filterable
                :allow-create="eqPm._allowEditingVessel"
                :default-value="form.vessel"
                :static-options="eqPm.vesselList"
                @parentCallBack="p=>{eqPm.onVesselSelectionChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Voyage')">
              <cargo-advance-select
                ref="voyageFlight"
                no="6"
                :static-options="eqPm._voyages || []"
                :cache="false"
                :default-value="form.voyageFlight"
                filterable
                clearable
                :allow-create="eqPm.editVoyageMode===1"
                tag-name="voyageNo"
                tag-value="voyageNo"
                :filter-tag-names="['voyageNo']"
                @focus="eqPm.txtVoyageFocusInHandler()"
                @parentCallBack="p=>{eqPm.onVoyageFlightChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompanyContractNo')">
              <el-input v-model="form.scNo" no="10" />
            </el-form-item>
            <el-form-item label="CNPT No.">
              <cargo-repeat-value-select
                v-model="form.cNptNo"
                :placeholder="''"
                no="cNptNo"
                filterable
                :allow-create="true"
                clearable
                :options="cNptList"
                label-field="no"
                value-field="no"
                unique-field="no"
                :match-of-repeat-value="matchOfCNpt"
                @change="cNptChangeHandler"
                @handleBlur="cNptBlurHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CarrierCode')">
              <el-input v-model="form.carrierCode" no="carrierCode" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="form.userDefinedRoleId1||''"
                :merge-load="true"
                @change="p=>{pm.userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column" style="width: 332px;">
          <el-form label-width="112px" label-position="right" style="height:100%" :disabled="readonly">
            <el-form-item :label="$t('SeaExport.itemCount')">
              <auto-number-input
                v-model="form.quantityContract"
                no="weightContract"
                :precision="3"
                :min="0"
                @change="pm.jobContractQwcChange(1)"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Weight')">
              <auto-number-input
                v-model="form.weightContract"
                no="weightContract"
                :precision="3"
                :min="0"
                @change="weightActualChange()"
              />
            </el-form-item>

            <el-form-item :label="$t('SeaExport.Cubage')">
              <auto-number-input
                v-model="form.cubageContract"
                no="92"
                :precision="3"
                :min="0"
                @change="cubageContractChange();"
              />
            </el-form-item>

            <el-form-item
              :label="$t('SeaExport.Package')"
            >
              <cargo-packing-select
                no="packing"
                :default-value="form.packing"
                @change="p=>{form.packing=p.value;pm.txtPackingChangeHandler()}"
              />
            </el-form-item>

            <el-form-item
              :label="$t('SeaExport.EnglishDescriptionOfGoods')"
            >
              <special-character-tip :texts="specialCharCheck.cargoEnglishName">
                <cargo-rich-textarea
                  ref="cargoTextarea1"
                  v-model="mblDoc.cargoEnglishName"
                  no="cargoEnglishName"
                  :text-chars="englishNameMaxChars"
                  :warning-count="englishNameWarningCount"
                  wrap-symbol="r"
                  :disabled="readonly"
                  auto-uppercase
                  auto-half-word
                  style="height: 110px"
                  @change="onCargoEnglishNameChange"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),mblDoc.cargoEnglishName,val=>{mblDoc.cargoEnglishName=val},false,null,true , {
                    warningCount: englishNameWarningCount, maxChar: englishNameMaxChars,autoUppercase:true,autoHalfWord:true
                  })"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Marks')"
            >
              <special-character-tip :texts="specialCharCheck.mark">
                <cargo-rich-textarea
                  ref="cargoTextarea2"
                  v-model="mblDoc.mark"
                  no="mark"
                  :text-chars="markMaxChars"
                  :warning-count="markWarningCount"
                  wrap-symbol="r"
                  :disabled="readonly"
                  auto-uppercase
                  auto-half-word
                  style="height: 110px"
                  @change="onMarkChange"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),mblDoc.mark,val=>{mblDoc.mark=val},false,null,true , {
                    warningCount: markWarningCount, maxChar: markMaxChars,autoUppercase:true,autoHalfWord:true
                  })"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HsCode')">
              <el-input
                v-model="mblDoc.hsCode"
                no="hsCode"
                type="textarea"
                :rows="5"
                style="width: 100%"
                @input="val=>{mblDoc.hsCode = val}"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),mblDoc.hsCode,val=>{mblDoc.hsCode = val})"
              />
            </el-form-item>

            <el-form-item :label="$t('SeaExport.bookingNotes')">
              <el-input
                v-model="form.remarks"
                no="remarks"
                type="textarea"
                :rows="4"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.remarks,val=>{form.remarks=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingPOR')">
              <el-input v-model="form.bargePOL" no="71" />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div
        class="section"
        style="width:100%"
      >
        <div class="form-row" style="display:flex;flex-direction:row;margin-top:8px">
          <el-form
            label-width="50px"
            label-position="left"
            style="margin-right:10px"
            :disabled="readonly"
          >
            <el-form-item
              :label="$t('SeaExport.Shipper')"
            >
              <el-input
                ref="shipperCode"
                v-model="mblDoc.shipperCode"
                no="16"
                style="width:180px;margin-right: 5px"
              />
              <el-button
                no="24"
                type="primary"
                :disabled="readonly"
                @click="onClear(1)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'shipperLine'+count"
              label-width="0"
            >
              <special-character-tip :texts="specialCharCheck['shipperLine'+count]">
                <cargo-input
                  :ref="'shipperLine'+count"
                  v-model="mblDoc['shipperLine'+count]"
                  :no="'shipperLine'+count"
                  :auto-uppercase="isUppercase"
                  :disabled="readonly"
                  :filter-chars="false"
                  :use-read-only="true"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,true,{autoHalfWord:true,autoUppercase:true,maxChar:maxChars,warningCount: warningCount})"
                  @change="()=>wrapAddr(mblDoc,'shipperLine'+count,count+1 > 7 ? null :'shipperLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
          <el-form
            label-width="65px"
            label-position="left"
            style="margin-right:20px"
            :disabled="readonly"
          >
            <el-form-item
              :label="$t('SeaExport.Consignee')"
            >
              <el-input
                ref="consigneeCode"
                v-model="mblDoc.consigneeCode"
                :disabled="readonly"
                no="19"
                style="width:180px;margin-right: 5px"
              />
              <el-button
                no="24"
                type="primary"
                :disabled="readonly"
                @click="onClear(2)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'consigneeLine'+count"
              label-width="0"
            >
              <special-character-tip :texts="specialCharCheck['consigneeLine'+count]">
                <cargo-input
                  :ref="'consigneeLine'+count"
                  v-model="mblDoc['consigneeLine'+count]"
                  :disabled="readonly"
                  :no="'consigneeLine'+count"
                  :auto-uppercase="isUppercase"
                  :filter-chars="false"
                  :use-read-only="true"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,true,{autoHalfWord:true,autoUppercase:true,maxChar:maxChars,warningCount: warningCount})"
                  @change="()=>wrapAddr(mblDoc,'consigneeLine'+count,count+1 > 7 ? null :'consigneeLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
          <el-form
            label-width="50px"
            label-position="left"
            style="margin-right:20px"
            :disabled="readonly"
          >
            <el-form-item
              :label="$t('SeaExport.NotifyParty')"
            >
              <el-input
                ref="notifyCode"
                v-model="mblDoc.notifyCode"
                :disabled="readonly"
                no="22"
                style="width:180px;margin-right: 5px"
              />
              <el-button
                no="24"
                type="primary"
                :disabled="readonly"
                @click="onClear(3)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'notifyLine'+count"
              label-width="0"
            >
              <special-character-tip :texts="specialCharCheck['notifyLine'+count]">
                <cargo-input
                  :ref="'notifyLine'+count"
                  v-model="mblDoc['notifyLine'+count]"
                  :disabled="readonly"
                  :no="'notifyLine'+count"
                  :auto-uppercase="isUppercase"
                  :filter-chars="false"
                  :use-read-only="true"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,true,{autoHalfWord:true,autoUppercase:true,maxChar:maxChars,warningCount: warningCount})"
                  @change="()=>wrapAddr(mblDoc,'notifyLine'+count,count+1 > 7 ? null :'notifyLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="section" style="width:100%">
        <span class="title">{{ $t('CargoMsg.Cargo_MultiLegVoyageManagement') }}</span>
        <div class="form-row" style="flex-direction:row;">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="leg.gridOptions"
            :column-defs="columnDefs"
            grid-style="height:100%;"
            :row-data="leg.rowData"
            @gridReady="params=>leg.gridApi=params.api"
          />
        </div>
      </div>
    </div>

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      append-to-body
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="!readonly"
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabBookingFCLPM } from '../tabBookingFCLPM'
import { TabVesselEqPM } from '../tabVesselEqPM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getCNptFunc } from '@/api/company'
import cargoRepeatValueSelect from '@/components/Cargo/Common/cargoRepeatValueSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import checkPermission from '@/utils/permission'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { MultiLegVoyageManagement } from '@/class/model/booking/MultiLegVoyageManagement'

export default {
  name: 'EdiBaseWindow',
  components: {
    cargoAdvanceSelect,
    bookingSeaEqDataGrid,
    cargoInput,
    specialCharacterTip,
    cargoRepeatValueSelect,
    cargoRichTextarea,
    cargoPackingSelect,
    cargoUserSelect,
    cargoCompanySelect,
    AutoNumberInput
  },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true, default: 'look' }
  },
  data() {
    return {
      loading: false,
      SEUtils,
      ContainerUtil,
      pm: new TabBookingFCLPM(this),
      eqPm: new TabVesselEqPM(this),
      selectTypeNames: TYPE_NAMES,
      form: new SeaExportJob().fillDefaultValue().getData(),
      mblDoc: new SeaCargoDoc().fillDefaultValue().getData(),
      hdoc: new SeaCargoDoc().fillDefaultValue().getData(),
      seaEqList: [],
      isTabContainerInfo: true, // // CARGO-7908 当基本页签切换非装箱信息页签不去覆盖基本页签实际件毛体(cargo 中在bookingworkspace 中设置的是true)
      btnSave: true,
      isUppercase: true,
      oldMark: '',
      oldCargoEnglishName: '',
      showMarkOrCargoEnglishNameDialog: false, // 英文品名唛头是否双击展示
      englishNameMaxChars: 0,
      englishNameWarningCount: 200,
      markMaxChars: 0,
      markWarningCount: 0,
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      },
      specialCharCheck: {
        cargoEnglishName: null,
        mark: null,
        shipperLine1: null,
        shipperLine2: null,
        shipperLine3: null,
        shipperLine4: null,
        shipperLine5: null,
        shipperLine6: null,
        shipperLine7: null,
        consigneeLine1: null,
        consigneeLine2: null,
        consigneeLine3: null,
        consigneeLine4: null,
        consigneeLine5: null,
        consigneeLine6: null,
        consigneeLine7: null,
        notifyLine1: null,
        notifyLine2: null,
        notifyLine3: null,
        notifyLine4: null,
        notifyLine5: null,
        notifyLine6: null,
        notifyLine7: null
      },
      leg: {
        gridApi: null,
        addKey: 'addLeg_',
        delMultiLegVoyageManagement: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          singleClickEdit: true,
          context: {
            componentParent: this
          }
        },
        rowData: []
      },
      JobUtils,
      cNptList: [],
      matchOfCNpt: options => {
        const option = options.find(p => p.no === this.form.cNptNo)
        return option || options[0]
      },
      maxChars: 200,
      warningCount: 35
    }
  },
  computed: {
    readonly() {
      return !this.isEdit
    },
    isEdit() {
      return this.action !== 'look' && !this.form.printHblZbLock && (!this.form.uuid || (this.form.uuid && checkPermission(['tab_SEBooking_EditBookingTab'])))
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.Voyage2'),
          field: 'leg',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.LoadingPort'), field: 'pol', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'code')
          }
        },
        {
          headerName: this.$t('SeaExport.dischargingPort'), field: 'pod', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'code')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'), field: 'vessel', width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoyageNo'), field: 'voyage', width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CarrierCode'),
          field: 'ediCode',
          width: 200
        },
        {
          headerName: 'ETD',
          field: 'etd',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: 'ETA',
          field: 'eta',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ]
    },
    config() {
      return this.context.config
    }
  },
  methods: {
    async onShow(form) {
      this.form = form
      this.seaEqList = form.seaEQ = form.seaEQ || []
      if (form.customerId) {
        await getCNptFunc(form.customerId).then(res => {
          this.cNptList = res.data
        })
      }
      this.maxChars = Number(this.config.get('SEShipperConsigneNotifyMaxchars')) || 45
      this.warningCount = Number(this.config.get('SEShipperConsigneNotifyWarningColor')) || 35
      // 从配置中读取英文品名最大字符数
      const maxChars = Number(this.config.get('SEEnglishDescriptionOfGoodsMaxchars'))
      if (maxChars > 0) {
        this.englishNameMaxChars = maxChars
      }
      // 从配置中读取海运出口MBL英文品名标红字符数
      const maxColor = Number(this.config.get('SEEnglishDescriptionOfGoodWarningColor'))
      if (maxColor > 0) {
        this.englishNameWarningCount = maxColor
      }
      // 从配置中读取唛头最大字符数
      const maxChars2 = Number(this.config.get('SEMarkMaxChars'))
      if (maxChars2 > 0) {
        this.markMaxChars = maxChars2
      }
      // 从配置中读取海运出口MBL唛头标红字符数
      const maxColor2 = Number(this.config.get('SEMarkWarningColor'))
      if (maxColor2 > 0) {
        this.markWarningCount = maxColor2
      }
      await this.pm.init()
      await this.eqPm.init()
      const job = new SeaExportJob(this.form)
      this.leg.rowData = []
      if (this.form.uuid) {
        await new MultiLegVoyageManagement(this.form).getMultiLegVoyageManagement()
        this.leg.rowData = this.form.multiLegVoyageManagement || []
      }
      this.mblDoc = await job.getMainMbl()
      this.hdoc = await job.getMainHbl()
      if (this.mblDoc) {
        this.mblDoc._mergeHblDataTime = new Date()
        this.mblDoc._markTime = new Date()
        this.mblDoc._cargoEnglishNameTime = new Date()
      }
    },
    eqQuantityChangeHandler() {
      ChargeUtils.eqQuantityChangeHandler(this.form, this.context)
    },
    closeAdvanceText() {
      this.showMarkOrCargoEnglishNameDialog = false
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    // 是否可选择一年以外的时间点
    disabledDate(time) {
      const startDate = new Date()
      startDate.setFullYear(startDate.getFullYear() - 1)
      const endDate = new Date()
      endDate.setFullYear(endDate.getFullYear() + 1)
      return (time.getTime() < startDate.getTime() || time.getTime() > endDate.getTime())
    },
    onMarkChange() {
      if (this.mblDoc) {
        this.mblDoc._mergeHblDataTime = new Date()
        this.mblDoc._markTime = new Date()
      }
    },
    onCargoEnglishNameChange() {
      if (this.mblDoc) {
        this.mblDoc._mergeHblDataTime = new Date()
        this.mblDoc._cargoEnglishNameTime = new Date()
      }
    },
    fillModel() {
      this.pm.fillModel()
    },
    async etaChange(value) {
      this.form.eta = value
    },
    async etdChange(value) {
      const oldValue = this.form.etd
      this.form.etd = value
      this.form.sailingDay = JobUtils.dateChange(this.form.etd)
      this.pm.ETDChange(oldValue)
      await ChargeUtils.updateETDFee(this.form, this.form.etd, this.context, true)
      if (this.form.etd) {
        JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.mblDoc['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.mblDoc['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.mblDoc['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.mblDoc['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.mblDoc['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.mblDoc['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.mblDoc['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.mblDoc['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.mblDoc['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.mblDoc['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.mblDoc['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.mblDoc['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.mblDoc['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.mblDoc['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.mblDoc['notifyLine' + i] = ''
      }
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: 45,
        maxChar: 45,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      if (title === this.$t('SeaExport.EnglishDescriptionOfGoods') || title === this.$t('SeaExport.Marks')) {
        this.showMarkOrCargoEnglishNameDialog = true
      }
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    onClear(type) {
      switch (type) {
        case 1:
          this.mblDoc.shipperCode = ''
          this.mblDoc.shipperLine1 = ''
          this.mblDoc.shipperLine2 = ''
          this.mblDoc.shipperLine3 = ''
          this.mblDoc.shipperLine4 = ''
          this.mblDoc.shipperLine5 = ''
          this.mblDoc.shipperLine6 = ''
          this.mblDoc.shipperLine7 = ''
          break
        case 2:
          this.mblDoc.consigneeCode = ''
          this.mblDoc.consigneeLine1 = ''
          this.mblDoc.consigneeLine2 = ''
          this.mblDoc.consigneeLine3 = ''
          this.mblDoc.consigneeLine4 = ''
          this.mblDoc.consigneeLine5 = ''
          this.mblDoc.consigneeLine6 = ''
          this.mblDoc.consigneeLine7 = ''
          break
        case 3:
          this.mblDoc.notifyCode = ''
          this.mblDoc.notifyLine1 = ''
          this.mblDoc.notifyLine2 = ''
          this.mblDoc.notifyLine3 = ''
          this.mblDoc.notifyLine4 = ''
          this.mblDoc.notifyLine5 = ''
          this.mblDoc.notifyLine6 = ''
          this.mblDoc.notifyLine7 = ''
          break
        default:
          break
      }
    },
    async weightActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.pm.refreshWeightCharge(this.form, this.form.weightActual)
      }
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.weightContract !== this.form.weightActual) {
          this.form.weightContract = this.form.weightActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.pm.refreshWeightCharge(this.form, this.form.weightContract)
          }
          ContainerUtil.refreshContainerUsageContractQwc(this.form, 'weightContract')
        }
      })
      if (!this.form.fba) {
        await this.pm.calculateChargeWeight()
      }
      this.pm.refContainerUsageQwc(2)
      if (!this.form.multipleDischargingPickups && this.form.dischargingTrucking && this.form.dischargingTrucking.length > 0) {
        this.form.dischargingTrucking[0].weight = this.form.weightActual || 0
        this.context.modifiedData.dischargingTruckingInfo = this.form.dischargingTrucking
      }
    },
    async cubageContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.pm.refreshCubageCharge(this.form, this.form.cubageContract)
      }
      this.pm.jobContractQwcChange(3)
    },
    cNptChangeHandler(value, option) {
      this.form.cNptName = ''
      if (option) {
        this.form.cNptNo = option.no
        this.form.cNptName = option.companyName
      }
    },
    cNptBlurHandler(value) {
      this.form.cNptName = ''
      if (value) {
        const cNpt = this.cNptList.find(item => item.no === value)
        if (cNpt) {
          this.form.cNptNo = cNpt.no
          this.form.cNptName = cNpt.companyName
        } else {
          this.form.cNptNo = value
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>
